module.exports = __webpack_public_path__ + "img/kia-service-stock-img.4315d879.jpeg";